import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import camelCase from 'lodash/camelCase';
import Select from 'components/ui/SelectField';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';
import { featureEnabled } from 'helpers/ToggleBot';

const StatusInput = ({ value, errors, touched, setFieldValue, viewDetails, disabled }) => {
  if (!viewDetails) return <React.Fragment />;

  const disableWorkingStatuses = featureEnabled(
    'ui.create_service_request.disable_working_statuses'
  );
  const scheduledDisabled =
    featureEnabled('maintenance.maintenance_dispatch') || disableWorkingStatuses;

  const statuses = [
    { value: 'new', disabled: false },
    { value: 'Reviewed', disabled: false },
    { value: 'Fixing', disabled: disableWorkingStatuses },
    { value: 'Fixed', disabled: false },
    { value: 'Parts Needed', disabled: disableWorkingStatuses },
    { value: 'Contractor Needed', disabled: disableWorkingStatuses },
    { value: 'Contact Tenant', disabled: false },
    { value: 'Closed', disabled: false },
    { value: 'Deferred', disabled: false },
    { value: 'auto_deferred', disabled: true },
    { value: 'Scheduled', disabled: scheduledDisabled },
    { value: 'Acknowledged', disabled: true },
    { value: 'Proposed Scheduled Date', disabled: true },
  ];

  if (featureEnabled('maintenance.maintenance_dispatch')) {
    statuses.push(
      { value: 'Contractor Needed Review', disabled: true },
      { value: 'Parts Needed Review', disabled: true }
    );
  }

  if (featureEnabled('maintenance.vendor_statuses_and_notifications')) {
    statuses.push(
      { value: 'vendor_ongoing', disabled: true },
      { value: 'vendor_other', disabled: true },
      { value: 'vendor_cancelled', disabled: true }
    );
  }

  if (featureEnabled('ui.create_service_request.assign_status')) {
    statuses.push({ value: 'assigned', disabled: false });
  }

  return (
    <Col span={24}>
      <Form.Item
        label={`${getTranslatedString(
          'landlordPortal.maintenance.tickets.assignmentAndScheduling.status'
        )}*`}
        validateStatus={touched.status && errors.status ? 'error' : null}
        help={touched.status && errors.status}
      >
        <Select
          name="status"
          showSearch
          placeholder={getTranslatedString(
            'landlordPortal.maintenance.tickets.assignmentAndScheduling.select'
          )}
          size="large"
          value={getTranslatedString(
            `landlordPortal.maintenance.tickets.assignmentAndScheduling.status.${camelCase(value)}`
          )}
          onChange={(value) => {
            setFieldValue('status', value);
          }}
          disabled={disabled}
        >
          {statuses
            .sort((a, b) => a.disabled - b.disabled)
            .map((status) => (
              <Select.Option value={status.value} disabled={status.disabled}>
                {getTranslatedString(
                  `landlordPortal.maintenance.tickets.assignmentAndScheduling.status.${camelCase(
                    status.value
                  )}`
                )}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
    </Col>
  );
};

export default StatusInput;
